module.exports = __webpack_public_path__ + "img/Meet-The-Team.30fe6690.webp";